/**
 * @typedef {import('./Response').default} Response
 * @typedef {import('../../../../App/shared/AgentService/ValuationData').ValuationResponse} Valuations
 */

import { agentService } from '../../../../service-container';
import { translate } from '../../../../App/Internationalization';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {number} [pageNumber]
 * @param {boolean} [isGated]
 * @returns {Response}
 */
export default function useGetAgentValuations(pageNumber = 1, isGated = false) {
	const [errorMessage, setErrorMessage] = useState('');
	const [isGettingData, setIsGettingData] = useState(true);
	const [lastPageNumber, setLastPageNumber] = useState(1);
	const [total, setTotal] = useState(0);
	const [valuations, setValuations] = useState(
		/** @type {Valuations[]} */ ([])
	);

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [pageNumber]);

	/** @returns {Promise<void>} */
	async function fetchData() {
		setIsGettingData(true);

		try {
			await getTableData();
		} catch (error) {
			captureError(error);
			setErrorMessage(translate('global.error'));
		} finally {
			setIsGettingData(false);
		}
	}

	/** @returns {Promise<void>} */
	async function getTableData() {
		const response = await agentService.getValuations(pageNumber);

		setLastPageNumber(response.pages ?? 1);
		setTotal(response.total ?? 0);
		setValuations(response.valuations);
	}

	return useMemo(
		() => ({
			data: valuations,
			errorMessage,
			isGettingData,
			lastPageNumber,
			total,
		}),
		[errorMessage, valuations, isGettingData, lastPageNumber, total]
	);
}
